import { SERVICE_URL } from "./app.const";
import { fetchGet, fetchPatch } from "./response";

export const fetchProfiles = (query, token) =>
  fetchGet(`${SERVICE_URL}/admin/profiles`, {
    ...query,
    role: query.role || undefined,
    status: query.status || undefined,
  }, token);

export const fetchProfile = (id, token) =>
  fetchGet(`${SERVICE_URL}/admin/profiles/${id}`, {}, token);

export const updateRoles = (id, roles, token) =>
  fetchPatch(`${SERVICE_URL}/admin/profiles/${id}/roles`, token, { roles });

export const updateStatus = (id, status, token) =>
  fetchPatch(`${SERVICE_URL}/admin/profiles/${id}/status`, token, { status });
